module.exports = __webpack_public_path__ + "img/wizard-online-store.d57827a0.png";